import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';
import { COURSE_EVENTS } from '@/content/values/events';
import { SECTION_TYPES } from '@/content/values/sections';
import { SectionProvider } from '@/sections/providers/section.provider';

@Component({
  name: 'ed-update-subject-project',
  components: {
    EdContentSections: () => import(/* EdContentSections */'@/sections/components/ed-content-sections/ed-content-sections.component.vue'),
    EdFunSections: () => import(/* EdFunSections */'@/sections/components/ed-fun-sections/ed-fun-sections.component.vue'),
    EdFillerSections: () => import(/* EdFillersSections */'@/sections/components/ed-filler-sections/ed-filler-sections.component.vue'),
    EdAdditionalSections: () => import(/* EdAdditionalSections */'@/sections/components/ed-additional-sections/ed-additional-sections.component.vue'),
  }
})
export default class EdUpdateSubjectProjectComponent extends Vue {

  /* Props */
  @Prop() readonly params: any;

  /* Data */
  public form: object = {}
  public saving: boolean = false;
  public loading: boolean = true;
  public sectionOptions = [];
  public iniProjectObjects = [];
  public projectObjects = [];
  public removeProjectObjects = [];
  public totalProjects = [];

  /* Computed */
  get hasContent() {
    return this.content?.sections ? this.content?.sections?.length > 0 : false;
  }

  get content() {
    return this.params.course;
  }

  /* Methods */
  closeModal() {
    this.$EdModal.closeModal();
  }

  save() {
    this.saving = true;
      this.$Courses.Store.saveProjectFilesA({
        parentId: this.params.project.projectId, 
        courseId: this.params.course.id, 
        classId: this.params.classId,
        addSections: this.projectObjects,
        removeSections: this.removeProjectObjects
      }).then(() => {
        this.saving = false;
        this.closeModal();
      }).catch((err) =>  {
        this.$EdToast.create({ 
          msg:  `${this.$t('courses.errors.errorSavingObject')}`,
          type: TOAST_TYPES.DANGER,
          top: '3rem',
          timeout: 3000
        });
        this.saving = false;
    })
  }

  addObjectProject(objectId) {
    if (!this.iniProjectObjects.includes(objectId)) {
      this.projectObjects.push(objectId)
    }
    this.totalProjects.push(objectId);
    this.$edEventBus.$emit(COURSE_EVENTS.SET_OBJECT_PROJECTS, this.totalProjects)
  }

  removeFromProject(objectId){
    this.projectObjects = this.projectObjects.filter(el => el !== objectId)
    this.totalProjects = this.totalProjects.filter(el => el !== objectId)
    this.$edEventBus.$emit(COURSE_EVENTS.SET_OBJECT_PROJECTS, this.totalProjects);
    if (this.iniProjectObjects.includes(objectId)) {
      this.removeProjectObjects.push(objectId)
    }
  }

  setInitialProjects(projects) {
    return projects.map(item => {
      if(item.projects.length > 0) 
        return this.setInitialProjects(item.projects)
      if (item.type === SECTION_TYPES.SECTION.code) 
        return item.section.id;
    });
  }

  mounted() {
    this.$edEventBus.$on(COURSE_EVENTS.ADD_OBJECT_PROJECT, this.addObjectProject)
    this.$edEventBus.$on(COURSE_EVENTS.REMOVE_OBJECT_PROJECT, this.removeFromProject)
    this.iniProjectObjects = this.totalProjects = this.setInitialProjects(this.params.project.projects);
    setTimeout(() => {
      this.$edEventBus.$emit(COURSE_EVENTS.SET_OBJECT_PROJECTS, this.iniProjectObjects)
    }, 1000)
  }
}